export const SITE_CONTROL_EVENTS = {
    SHOW_ON_KBB_CLOSE: 107147
};
